// Global Types
import type {
  $Translate,
} from 'common.language';
// Global Types
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  FormSection,
} from '@vroskus/library-components';

// Helpers
import {
  cleanFormValues,
} from '@vroskus/library-helpers/dist/browser';
import {
  defaultUpsertItem,
} from '../../../../helpers';

// Components
import ProfileInvoiceFields from '../../../fields/ProfileInvoiceFields';

// Services
import Services from '../../../../services';

// Types
import type {
  $ReducerState,
} from '../../../../redux';

export type $OwnProps = $Translate & {
  id: string;
};

export type $StateProps = {
  auth: $ReducerState<'auth'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  changed: boolean;
};

class ProfileInvoiceDetailsSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      changed: false,
    };
  }

  render() {
    const {
      auth: {
        user,
      },
      id,
      t,
    } = this.props;
    const {
      changed,
    } = this.state;

    return (user !== null ? (
      <FormSection
        changed={changed}
        fields={(
          <ProfileInvoiceFields
            item={user}
            onChange={() => this.setState({
              changed: true,
            })}
          />
        )}
        headerTitle={t('Invoice details')}
        id={id}
        labelClearButton={t('Clear')}
        labelSaveButton={t('Save')}
        onAction={(values) => defaultUpsertItem({
          action: async () => {
            const params = cleanFormValues<$Model<'Admin'>>({
              ...user,
              ...values,
            });

            await Services.Api.updateAuthUser(params);

            this.setState({
              changed: false,
            });
          },
        })}
      />
    ) : null);
  }
}

export default ProfileInvoiceDetailsSectionView;
